var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("div", { staticClass: "product-display--wrapper" }, [
        _c("div", { staticClass: "product-display" }, [
          _c("div", {
            staticClass: "product-slider__background",
            style: _vm.getSliderStyling,
          }),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "small-12 medium-7 column product-slider__wrapper",
                },
                [_c("product-carousel", { attrs: { product: _vm.product } })],
                1
              ),
              _vm.$mq !== "mobile"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "small-12 medium-5 column product-display__content",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "product-info" },
                        [_vm._t("content")],
                        2
                      ),
                      _vm.product.type === "Gift Card"
                        ? _c("product-form-gift-card", {
                            attrs: { product: _vm.product },
                          })
                        : _c("product-form", {
                            attrs: { product: _vm.product },
                          }),
                      _vm._t("icons"),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm.$mq === "mobile"
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "column small-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "product-info" },
                      [_vm._t("content")],
                      2
                    ),
                    _vm.product.type === "Gift Card"
                      ? _c("product-form-gift-card", {
                          attrs: { product: _vm.product },
                        })
                      : _c("product-form", { attrs: { product: _vm.product } }),
                    _vm._t("icons"),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _c("div", { staticClass: "product-display--placeholder" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }